import React, { useEffect, useCallback } from "react";
import { showUpdatePremiseAlert } from "../Form/helper";
import { AccountPayer } from "../Form/types";
import FormContext from "src/context/FormContext";

export const useUpdateSidebarStatus = (
  accountPayers: (AccountPayer | undefined)[],
  hasAccountId: boolean,
  blockName: string,
  existingPremise: boolean
) => {
  const { sidebarStatus, setSidebarStatus } = React.useContext(FormContext);

  const updateStatus = useCallback(
    (shouldShowAlert: boolean) => {
      const currentStatus = sidebarStatus[blockName];
      const newStatus = shouldShowAlert ? "warning" : undefined;

      if (currentStatus !== newStatus) {
        setSidebarStatus((prev) => ({
          ...prev,
          [blockName]: newStatus,
        }));
      }
    },
    [blockName, sidebarStatus, setSidebarStatus]
  );

  useEffect(() => {
    const validAccountPayers = accountPayers.filter(
      (payer): payer is AccountPayer => !!payer
    );

    const shouldShowAlert = showUpdatePremiseAlert(
      validAccountPayers,
      hasAccountId,
      existingPremise
    );

    updateStatus(shouldShowAlert);
  }, [accountPayers, hasAccountId, updateStatus]);
};
